import { Box, Center, Container, Divider, Group, Radio, SegmentedControl, Switch, Text, Title, useMantineColorScheme } from '@mantine/core';
import { useLocalStorage } from '@mantine/hooks';
import { IconMoon, IconSun } from '@tabler/icons-react';
import { FormInputWrapper } from 'core/components/';
import { AppConstants } from 'utils/constants';

import { useState } from 'react';
import { Card, Stack, Badge, SimpleGrid } from '@mantine/core';
import { logger } from 'utils/logger';
import { setKeywordHighlighting } from './settingsSlice';
import { connect, useDispatch } from 'react-redux';

const SettingsModule = ({keywordHighlighting, setKeywordHighlighting}) => {
    const { colorScheme } = useMantineColorScheme();
    const [searchMode, setSearchMode] = useLocalStorage({ key: 'oi-global-search-type', defaultValue: 'basic' });
    const dispatch = useDispatch();

    return (
        <Box
            id='settingsModule'
            sx={(theme) => ({
                backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.white,
                width: '100%',
            })}>
            <Container mt={'xl'}>
                <Box px='lg'>
                    <Group
                        className='main-container-header'
                        position='apart'
                        sx={(theme) => ({
                            borderBottom: `1px solid`,
                            borderColor: theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[2],
                            backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.white,
                        })}>
                        {/* <Crumbline></Crumbline> */}
                        <Box>
                            <Title order={4}>Workspace Settings</Title>
                            <Text size={'sm'}>Manage your workspace</Text>
                        </Box>
                    </Group>

                    <Group className='container-action-bar' sx={{ width: '100%' }} position='apart' height={'100%'} py='xs' mt='sm'>
                        <Box sx={{ width: '100%' }}>
                            <Group position='apart'>
                                <Title className='main-content-heading' order={5} mb='xs'>
                                    Notifications
                                </Title>
                            </Group>

                            <FormInputWrapper labelWidth={200} label='Enable browser notifications' id='input-notifications'>
                                <Group position='right' sx={{ margin: 0 }}>
                                    <Switch defaultChecked></Switch>
                                </Group>
                            </FormInputWrapper>

                            <Divider />

                            <Group position='apart' mt={'xl'}>
                                <Title className='main-content-heading' order={5} mb='xs'>
                                    Theme
                                </Title>
                            </Group>

                            <FormInputWrapper labelWidth={'auto'} label='Set the theme for your workspace' id='input-notifications'>
                                <Group position='right' sx={{ marginTop: -24 }}>
                                    <SegmentedToggle />
                                </Group>
                            </FormInputWrapper>
                            <Divider />
                            <Group position='apart' mt={'xl'}>
                                <Title className='main-content-heading' order={5} mb='xs'>
                                    Search
                                </Title>
                            </Group>

                            <FormInputWrapper labelWidth={'auto'} label='Enable keyword highlighting' id='input-notifications'>
                                <Group position='right' >
                                    <Switch checked={keywordHighlighting} onChange={(e) => dispatch(setKeywordHighlighting(e.currentTarget.checked))} />
                                </Group>
                            </FormInputWrapper>

                            {/* <Divider />
                            <Group position='apart' mt={'xl'}>
                                <Title className='main-content-heading' order={5} mb='xs'>
                                    Global Search
                                </Title>
                            </Group> */}

                            <FormInputWrapper labelWidth='auto' description='Select the search mode for your workspace' label='Global Search' id='input-global-search'>
                                <Group position='start' sx={{ marginTop: -24 }}>
                                    <Group position='start' pt={'sm'} my='xl'>
                                        <SearchPlanCards value={searchMode} onChange={setSearchMode} theme={colorScheme} />
                                    </Group>
                                </Group>
                            </FormInputWrapper>

                            <Text color='dimmed' pt={13} size={'xs'}>
                                OnSet v{AppConstants.APP_VERSION}
                            </Text>
                        </Box>
                    </Group>
                </Box>
            </Container>
        </Box>
    );
};

const mapStateToProps = (state, props) => {
    //logger.log(state,props, ' mapstate')
    return {
        keywordHighlighting: state.settingsReducer.keywordHighlighting,
    };
};

const mapDispatchToProps = { setKeywordHighlighting };

export default connect(mapStateToProps, mapDispatchToProps)(SettingsModule);

const SegmentedToggle = () => {
    const { colorScheme, toggleColorScheme } = useMantineColorScheme();

    return (
        <Group position='center' my='xl'>
            <SegmentedControl
                value={colorScheme}
                onChange={(value) => toggleColorScheme(value)}
                data={[
                    {
                        value: 'light',
                        label: (
                            <Center>
                                <IconSun size={16} stroke={1.5} />
                                <Box ml={10}>Light</Box>
                            </Center>
                        ),
                    },
                    {
                        value: 'dark',
                        label: (
                            <Center>
                                <IconMoon size={16} stroke={1.5} />
                                <Box ml={10}>Dark</Box>
                            </Center>
                        ),
                    },
                ]}
            />
        </Group>
    );
};

function BasicSVG(dark) {
    const bg = dark ? '#1c1f26' : '#f8f9fa';
    const surface = dark ? '#272b34' : '#ffffff';
    const line = dark ? '#2d3139' : '#dee2e6';
    const textHigh = dark ? '#e5e7eb' : '#1c1f26';
    const textMid = dark ? '#6b7280' : '#9ca3af';
    const accentFill = dark ? 'rgba(55,138,221,0.2)' : 'rgba(25,113,194,0.1)';
    const accentStroke = dark ? 'rgba(55,138,221,0.5)' : 'rgba(25,113,194,0.4)';
    const green = dark ? 'rgba(29,158,117,0.35)' : 'rgba(29,158,117,0.2)';

    return (
        <svg viewBox='0 0 200 100' width='100%' xmlns='http://www.w3.org/2000/svg'>
            <rect width='200' height='100' fill={bg} />
            <rect x='14' y='14' width='172' height='22' rx='5' fill={surface} />
            <circle cx='27' cy='25' r='5.5' fill='none' stroke={textMid} strokeWidth='1.4' />
            <line x1='31' y1='29' x2='34' y2='32' stroke={textMid} strokeWidth='1.4' strokeLinecap='round' />
            <rect x='40' y='21' width='55' height='8' rx='4' fill={accentFill} />
            <rect x='40' y='21' width='55' height='8' rx='4' fill='none' stroke={accentStroke} strokeWidth='.5' />
            <line x1='14' y1='46' x2='186' y2='46' stroke={line} strokeWidth='.75' />
            <rect x='14' y='54' width='172' height='15' rx='3' fill={surface} />
            <rect x='18' y='58' width='50' height='7' rx='3.5' fill={textHigh} opacity='.7' />
            <rect x='140' y='58' width='42' height='7' rx='3.5' fill={green} />
            <rect x='14' y='74' width='172' height='11' rx='3' fill={surface} opacity='.6' />
            <rect x='18' y='77' width='36' height='5' rx='2.5' fill={textMid} opacity='.5' />
            <rect x='14' y='89' width='172' height='8' rx='3' fill={surface} opacity='.35' />
            <rect x='18' y='91' width='28' height='4' rx='2' fill={textMid} opacity='.3' />
        </svg>
    );
}

function AdvancedSVG(dark) {
    const bg = dark ? '#1c1f26' : '#f8f9fa';
    const surface = dark ? '#272b34' : '#ffffff';
    const line = dark ? '#2d3139' : '#dee2e6';
    const textHigh = dark ? '#e5e7eb' : '#1c1f26';
    const textMid = dark ? '#6b7280' : '#9ca3af';
    const accent = dark ? '#378ADD' : '#1971c2';
    const colHeader = dark ? '#272b34' : '#f1f3f5';

    const dataRows = [59, 68, 77, 86].map((y, i) => {
        const op = (0.75 - i * 0.18).toFixed(2);
        return (
            <g key={y}>
                <rect x='17' y={y} width='38' height='5' rx='2.5' fill={textHigh} opacity={op} />
                <rect x='70' y={y} width='28' height='5' rx='2.5' fill={textHigh} opacity={op} />
                <rect x='115' y={y} width='22' height='5' rx='2.5' fill={textHigh} opacity={op} />
                <rect x='155' y={y} width='26' height='5' rx='2.5' fill={textHigh} opacity={op} />
            </g>
        );
    });

    return (
        <svg viewBox='0 0 200 100' width='100%' xmlns='http://www.w3.org/2000/svg'>
            <rect width='200' height='100' fill={bg} />
            <rect x='14' y='14' width='172' height='22' rx='5' fill={surface} />
            <circle cx='27' cy='25' r='5.5' fill='none' stroke={textMid} strokeWidth='1.4' />
            <line x1='31' y1='29' x2='34' y2='32' stroke={textMid} strokeWidth='1.4' strokeLinecap='round' />
            <rect x='40' y='21' width='72' height='8' rx='4' fill={textMid} opacity='.3' />
            <rect x='157' y='17' width='28' height='16' rx='3' fill={surface} stroke={line} strokeWidth='.5' />
            <rect x='160' y='20' width='6' height='3' rx='1' fill={textMid} opacity='.5' />
            <rect x='160' y='25' width='6' height='3' rx='1' fill={accent} opacity='.6' />
            <rect x='160' y='30' width='6' height='3' rx='1' fill={textMid} opacity='.4' />
            <line x1='14' y1='46' x2='186' y2='46' stroke={line} strokeWidth='.75' />
            <rect x='14' y='47' width='186' height='8' fill={colHeader} />
            <rect x='17' y='49' width='30' height='4' rx='2' fill={accent} opacity='.55' />
            <rect x='70' y='49' width='22' height='4' rx='2' fill={textMid} opacity='.3' />
            <rect x='115' y='49' width='18' height='4' rx='2' fill={textMid} opacity='.3' />
            <rect x='155' y='49' width='26' height='4' rx='2' fill={textMid} opacity='.3' />
            <line x1='14' y1='55' x2='186' y2='55' stroke={line} strokeWidth='.5' />
            <line x1='66' y1='46' x2='66' y2='100' stroke={line} strokeWidth='.5' />
            <line x1='111' y1='46' x2='111' y2='100' stroke={line} strokeWidth='.5' />
            <line x1='151' y1='46' x2='151' y2='100' stroke={line} strokeWidth='.5' />
            {dataRows}
        </svg>
    );
}

const OPTIONS = [
    {
        value: 'basic',
        label: 'Basic',
        description: 'Quick spotlight search by Style Number',
        badge: { label: 'Default', color: 'gray' },
        graphic: BasicSVG,
    },
    {
        value: 'advanced',
        label: 'Advanced',
        description: 'Full-text search across all fields. Results are displayed in a paginated table view.',
        badge: { label: 'Recommended', color: 'blue' },
        graphic: AdvancedSVG,
    },
];

export function SearchPlanCards({ value, onChange, theme }) {
    logger.log('theme', theme);
    return (
        <SimpleGrid cols={2} spacing='md' breakpoints={[{ maxWidth: 'xs', cols: 1 }]}>
            {OPTIONS.map((opt) => {
                const selected = value === opt.value;
                return (
                    <Card
                        key={opt.value}
                        withBorder
                        radius='md'
                        padding='md'
                        onClick={() => onChange(opt.value)}
                        sx={(theme) => ({
                            cursor: 'pointer',
                            border: selected ? `2px solid ${theme.colors.brand[4]}` : `1.5px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]}`,
                            //   backgroundColor: selected
                            //     ? theme.colorScheme === 'dark'
                            //       ? theme.colors.brand[9]
                            //       : theme.colors.brand[0]
                            //     : theme.colorScheme === 'dark'
                            //     ? theme.colors.dark[6]
                            //     : theme.white,
                            transition: 'border-color 150ms ease',
                            '&:hover': {
                                borderColor: selected ? theme.colors.brand[4] : theme.colorScheme === 'dark' ? theme.colors.dark[3] : theme.colors.gray[5],
                            },
                        })}>
                        <Stack spacing='xs'>
                            <Box sx={{ borderRadius: 6, overflow: 'hidden', lineHeight: 0 }}>{opt.graphic(theme === 'dark')}</Box>

                            <Group position='apart' align='center' noWrap>
                                <Stack spacing={2}>
                                    <Text size='sm' weight={500}>
                                        {opt.label}
                                    </Text>
                                    <Text size='xs' color='dimmed'>
                                        {opt.description}
                                    </Text>
                                </Stack>

                                {/* Radio indicator */}
                                <Radio checked={selected}  onChange={() => {}}/>
                                {/* <Box
                  sx={(theme) => ({
                    width: 18,
                    height: 18,
                    borderRadius: '50%',
                    flexShrink: 0,
                    border: `1.5px solid ${
                      selected ? theme.colors.brand[5] : theme.colors.gray[4]
                    }`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  })}
                >
                  {selected && (
                    <Box
                      sx={(theme) => ({
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        backgroundColor: theme.colors.brand[6],
                      })}
                    />
                  )}
                </Box> */}
                            </Group>
                        </Stack>
                    </Card>
                );
            })}
        </SimpleGrid>
    );
}
